import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  // Load language from localStorage on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('vetcare-language') || 'en';
    setLanguage(savedLanguage);
    // Keep page direction as LTR always - only translate content
    document.documentElement.lang = savedLanguage;
  }, []);

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'ar' : 'en';
    setLanguage(newLanguage);
    localStorage.setItem('vetcare-language', newLanguage);
    // Keep page direction as LTR always - only translate content
    document.documentElement.lang = newLanguage;
  };

  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('vetcare-language', lang);
    // Keep page direction as LTR always - only translate content
    document.documentElement.lang = lang;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}

// Helper function to extract text based on language
export const getLanguageText = (bilingual, language) => {
  if (typeof bilingual === 'string') {
    // If it's a combined string like "English / العربية"
    const parts = bilingual.split(' / ');
    return language === 'ar' ? parts[1]?.trim() || parts[0] : parts[0];
  }
  // If it's an object like { en: "...", ar: "..." }
  return bilingual?.[language] || bilingual?.en || '';
};
